export default __webpack_public_path__ + "static/media/reg_huehuetenango.5d37f833.jpg";